<template>
  <div class="et-tabox">
    <div class="et-noticebox">
      <dl v-if="detailsTxte1.length == 0">
        <dt class="et-notice-link" style="padding-right: 25px">
          <p>1. 活动要求与规则<i class="icon-r"></i></p>
        </dt>
        <dd style="display: none">
          <p>
            请务必如实填写您的真实信息，以便活动发起方能够及时的与您取得联系。（保密承诺：您的信息将会被保密，请您放心填写。）
          </p>
        </dd>
      </dl>
      <dl v-for="item in detailsTxte1">
        <dt class="et-notice-link" style="padding-right: 25px">
          <p>{{item.order}}. {{item.title}}<i class="icon-r"></i></p>
        </dt>
        <dd style="display: none">
          <p v-html="item.text">
          </p>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
  export default {
    props: [
      'detailsTxte'
    ],
    data() {
      return {
        detailsTxte1: []
      }
    },
    methods: {
      //操作按钮事件
    },
    created: function () {
      var that = this;
      var id = this.$route.params.id;
     // this.$http.get(API.GetActivitieById, {params: {id: id}})
       // .then(function (res) {
         // if (res.code == 0) {
          //  console.log('attention_info');
          //  console.log(that.detailsTxte);
            if (that.detailsTxte) {
              if (that.detailsTxte.attention_info) {
                //  console.log(that.detailsTxte);
                that.detailsTxte1 = JSON.parse(that.detailsTxte.attention_info).attention_info;
              }
              //  console.log(that.detailsTxte1);
              //  else {
              //   that.detailsTxte1 = []
              // }
              that.$nextTick(function () {
                var et = $('.et-notice-link').eq(0);
                et.addClass('notice-down').find('.icon-r').css({
                  'transform': 'rotate(180deg)',
                  '-webkit-transform': 'rotate(180deg)',
                  'transition': 'all 0.5s'
                });
                et.parent().siblings().children('dt').next().slideUp();
                et.next().slideDown();
              })

            }
            //console.log(that.detailsTxte1)
        /*  } else {
            var et = $('.et-notice-link').eq(0);
            et.addClass('notice-down').find('.icon-r').css({
              'transform': 'rotate(180deg)',
              '-webkit-transform': 'rotate(180deg)',
              'transition': 'all 0.5s'
            });
            et.parent().siblings().children('dt').next().slideUp();
            et.next().slideDown();
            console.log('请求数据信息出错')
          }*/

       // });
    },
    mounted: function () {
      //操作DOM
      // 须知展开收起
      $('.et-tabox').on('click', '.et-notice-link', function () {
        if ($(this).hasClass('notice-down')) {
          $(this).removeClass('notice-down').find('.icon-r').css({
            'transform': 'rotate(90deg)',
            '-webkit-transform': 'rotate(90deg)',
            'transition': 'all 0.5s'
          });
          $(this).next().slideUp();
        } else {
          $(this).addClass('notice-down').find('.icon-r').css({
            'transform': 'rotate(180deg)',
            '-webkit-transform': 'rotate(180deg)',
            'transition': 'all 0.5s'
          });
          $(this).parent().siblings().children('dt').removeClass('notice-down').find('.icon-r').css({
            'transform': 'rotate(90deg)',
            '-webkit-transform': 'rotate(90deg)',
            'transition': 'all 0.5s'
          });
          $(this).parent().siblings().children('dt').next().slideUp();
          $(this).next().slideDown();
        }

      })
    }

  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/entryform/signUp.vue